import { default as ReactGA4 } from 'react-ga4';
import { NextRouter } from 'next/router';
import { LOG_URL, PLATFORM, CONTENT_TYPE, LSTORAGE_KEY } from '@zmedia/bm-soccer-ui/constants';
import { LocalStore, StringUtils } from './';
import { getGy, getVisitorID } from './cookie';
import { Logger } from './logger';
import { buildURLWithParam } from './common';

export const buildTrackingContent = (
    contentType: CONTENT_TYPE | undefined | string,
    tracking: string,
    index: number
) => {
    if (contentType === CONTENT_TYPE.AD_NATIVE) {
        return tracking;
    }

    return `${tracking}|index${index}`;
};

export const trackingPage = (
    key: string,
    value?: number,
    uid?: string,
    source?: string,
    router?: NextRouter
) => {
    let _key = key;
    let _value = value;
    let _source: any;
    let _index: number = 0;
    let _push = false;

    if (key === PLATFORM + '_article') {
        const { utmSource, utmMedium, utmCampaign } = (
            window as any
        )._BM;

        if (utmSource && utmMedium && utmCampaign) {
            _key = utmSource + '_' + utmMedium + '_' + utmCampaign + ':' + _key;
            _push = (window as any).firstLoad;
        }

        const hash = window.location.hash.substring(1);
        if (hash.indexOf('search') > -1) {
            ReactGA4.event({
                category: 'desktop_search',
                action: 'clickItemSearch',
            });

        }
        if (hash) {
            _source = hash.split('|index')[0];
            _index = +hash.split('|index')[1];
            if (router) {
                router.replace(window.location.pathname);
            }
        }


    }
    const _data = {
        key: _key,
        value: _value,
        source: source || _source,
        uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
        index: _index,
        utmDirect: _push,
    };

    fireTracking('/log', _data);

    if (_push) {
        (window as any).firstLoad = false;
    }
};

export const trackingContent = (
    source: string,
    contentId: number,
    uid: string
) => {
    if (!contentId || !source) {
        return;
    }
    const _data = {
        key: 'imps/webtrack/article',
        value: `${contentId}`,
        uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
        source: source.split('|index')[0],
        index: +source.split('|index')[1],
    };

    fireTracking('/imps', _data);
};

export const trackingAdNative = (key: string) => {
    if (!key) {
        return;
    }

    const _data = {
        key,
        rand: Math.random(),
    };

    tracking(LOG_URL + '/imps', _data);
};

export const fireTracking = (type: string, data = {}) => {
    let _visitorId = getVisitorID();
    if (!_visitorId) {
        document.addEventListener('ZA.onready', () => {
            buildTrackingLog(type, data);
        });
    } else {
        buildTrackingLog(type, data);
    }
};

const buildTrackingLog = (type: string, data = {}) => {
    let _data;
    try {
        _data = window.btoa(
            StringUtils.stringify({
                rand: Math.random(),
                visitorId: getVisitorID(),
                gy: getGy(),
                ...data,
            })
        );
    } catch (e) {
        Logger.error('tracking', 'fireTracking fail | ', e, 'type ', type);
    }

    if (_data) {
        tracking(LOG_URL + type, { data: _data });
    }
};

export function tracking(url: string, params: object) {
    const _url = buildURLWithParam(url, params);
    const img = document.createElement('img');

    img.setAttribute('src', _url);
    img.setAttribute('style', 'display:none');
}

export function formatTrackingUrl(url: string, tracking?: string): string {
    if (url) {
        return url.indexOf('#') > -1 ? url : url + '#' + tracking;
    }

    return '';
}

export function formatClickTrackingUrl(url: string): string {
    let result = url;
    const tracking = url.split('#')[1];
    const _tracking =
        tracking && tracking.indexOf('detail') < 0
            ? (window as any).pageType + tracking
            : tracking;
    result = url.split('#')[0] + '#' + _tracking;
    return result;
}

export function removeTrackingUrl(url: string): string {
    return url.split('#')[0];
}

export function srcImpsTracking(referrer: string): string {
    const test = /baomoi.com|dr.zapps.vn/i.test(referrer);
    const { utmSource } = (window as any)._BM;
    const fromZalo = utmSource === 'zalo';
    if (referrer && !test) {
        return `direct|${referrer.split('/')[2]}`;
    }
    if (fromZalo) {
        return `direct|zalo`;
    }
    return '';
}